/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import { readableColor } from 'polished';
import { colors } from '../../gatsby-plugin-theme-ui';

const textStyles = (type, parentBg) => {
  const globalStyles = {
    mb: '2.4rem',
  };
  switch (type) {
    case 'Callout':
      return {
        ...globalStyles,
        fontSize: '4rem',
        lineHeight: 1.25,
        mb: '7rem',
        color: readableColor(colors[parentBg], colors.SecondaryBlue2, '#fff'),
      };
    case 'Callout With No Bottom Padding':
      return {
        ...globalStyles,
        fontSize: '4rem',
        lineHeight: 1.25,
        color: readableColor(colors[parentBg], colors.SecondaryBlue2, '#fff'),
      };
    case 'Caption':
      return {
        ...globalStyles,
        fontSize: '1.4rem',
        lineHeight: '3.2rem',
        maxWidth: '70rem',
      };
    case 'Emphasised Paragraph':
      return {
        ...globalStyles,
      };
    default:
      return null;
  }
};

export const Text = ({ type, parentBg, ...props }) => (
  <div
    sx={{
      ...textStyles(type, parentBg),
    }}
    {...props}
  />
);

Text.propTypes = {
  type: PropTypes.oneOf(['Callout', 'Callout With No Bottom Padding', 'Caption', 'Emphasised Paragraph']).isRequired,
  parentBg: PropTypes.string,
};

Text.defaultProps = {
  parentBg: 'background',
};
